import { FormEventHandler } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Submit from 'src/components/FormComponents/Submit'
import { selectSelectedSalesChannels, selectStockAddressingFile } from '../../StockAddressingInBatchSelectors'
import { actions } from '../../StockAddressingInBatchState'
import * as S from './SubmitFileForm.styles'

export default () => {
  const dispatch = useDispatch()

  const selectedSalesChannels = useSelector(selectSelectedSalesChannels)
  const selectedFile = useSelector(selectStockAddressingFile)

  const canSubmitForm = selectedSalesChannels.length && selectedFile

  const onSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault()

    if (!canSubmitForm) {
      return
    }

    dispatch(actions.submitStockAddressingFile({
      file: selectedFile,
      salesChannels: selectedSalesChannels.map((s) => s.salesChannel),
    }))
    dispatch(actions.resetUploadPage())
  }

  return (
    <S.Form onSubmit={onSubmit}>
      <S.Submit as={Submit} text='Enviar' disabled={!canSubmitForm} />
    </S.Form>
  )
}
